import { AxiosError } from 'axios'
import { ENDPOINT_PROJECT_SETTINGS } from '../config'
import type { UpdateProjectSettingsRequest } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const updateProjectSettings = async (
  workspaceSlug: string,
  projectId: string,
  request: UpdateProjectSettingsRequest,
): Promise<void> => {
  try {
    await AuthAxios.patch(
      `${ENDPOINT_PROJECT_SETTINGS}/${workspaceSlug}/projects/${projectId}/settings`,
      request,
    )
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 403) {
        throw new Error('You do not have permission to change settings for this project')
      }
      if (error.response?.status === 400 && typeof error.response.data?.message === 'string') {
        throw new Error(error.response.data.message)
      }
    }
    throw error
  }
}

export default updateProjectSettings
